<template>
  <div>

    <div class="iaa-navbar" v-bind:class="{'activeSearch': toggleSearch}"> <!-- v-bind:class="{'activeSearch': toggleSearch}" -->
      <div class="container-fluid">
        <div class="iaa-navbar-content">
          <router-link class="nav-logo" :to="{ name: 'home' }">
            <img :src="logo.mini_logo ? logo.mini_logo : require('../assets/logo.png')" alt="logo" class="logo-img">
            <div class="logo-title" v-html="logo.title ? logo.title : 'IAAMC'"></div>
          </router-link>

          <div v-bind:class="{'active': toggleNavbar}" class="iaa-navbar-links">
            <router-link v-if="(header[0]) ? header[0].status : false" to="/accreditations" class="nav-link">Accreditation 
              <span class="sr-only">(current)</span>
            </router-link>
            <router-link v-if="(header[8]) ? header[8].status : false" to="/our-certificates" class="nav-link">Certification</router-link>
            <router-link v-if="(header[1]) ? header[1].status : false" to="/programs" class="nav-link">Programs</router-link>
            <router-link v-if="(header[2]) ? header[2].status : false" to="/memberships" class="nav-link">Membership</router-link>
            <router-link v-if="(header[3]) ? header[3].status : false" to="/about" class="nav-link">About</router-link>
            <router-link v-if="(header[4]) ? header[4].status : false"  to="/contact" class="nav-link">Contact Us</router-link>
            <router-link v-for="(pg, idy) in pages" :key="'p'+idy" :class="(pg.has_header) ? '' : 'hidden'" :to="{ name: 'show-page', params:{slug: pg.slug}}" 
              class="nav-link">
              {{ pg.title }}
            </router-link>
            <a @click="opnPopular(pop.slug)"  class="nav-link hidden-sm"
                v-for="(pop, idx) in popularSearch" :key="'s'+idx">
              {{ pop.title }}
            </a>
          </div>

          <div class="iaa-navbar-sa d-flex align-items-center">
            <button v-if="authenticated"
                  type="button"
                  name="button"
                  class="navbar-action"
                  data-toggle="dropdown">
                <div class="showDropdown">
                    <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                        alt="" 
                        class="img-fluid" 
                        style="width:38px;height:38px;border-radius: 50%;">
                    <div class="dropdown-menu">
                      <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                      <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                    </div>
                </div>
            </button>
            <router-link to="/login" v-if="!authenticated" class="iaa-sa">
              <span class="icon-user"></span>
            </router-link>
            <span class="iaa-nav-line">|</span>
            <button @click="toggleSearch = !toggleSearch" class="iaa-sa">
              <span v-if="!toggleSearch" class="icon-search"></span>
              <span v-else class="icon-cancel"></span>
            </button>
            <div @click="toggleNavbar = !toggleNavbar" class="menu-bar">
              <div class="child-bar-1"></div>
              <div class="child-bar-2"></div>
              <div class="child-bar-3"></div>
            </div>

          </div>
        </div>
      </div>
    </div>
    
    <!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <router-link :to="{ name: 'home' }">
          <img src="../assets/logo.png" alt="logo" class="logo-img">
        </router-link>
        <router-link :to="{ name: 'home' }" class="navbar-brand logo">IAAMC</router-link>
        <button class="navbar-toggler" 
              type="button" 
              data-toggle="collapse" 
              data-target="#navbarSupportedContent" 
              aria-controls="navbarSupportedContent" 
              aria-expanded="false" 
              aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto ml-auto">
            
            <li v-if="(header[0]) ? header[0].status : false" class="nav-item active">
               <router-link to="/accreditations" class="nav-link">Accreditation 
                <span class="sr-only">(current)</span>
              </router-link>
            </li>
            <li v-if="(header[8]) ? header[8].status : false" class="nav-item">
              <router-link to="/our-certificates" class="nav-link">Certification</router-link>
            </li>
            <li v-if="(header[1]) ? header[1].status : false" class="nav-item">
              <router-link to="/programs" class="nav-link">Programs</router-link>
            </li>
            <li v-if="(header[2]) ? header[2].status : false" class="nav-item">
              <router-link to="/memberships" class="nav-link">Membership</router-link>
            </li>
            <li v-if="(header[3]) ? header[3].status : false" class="nav-item">
              <router-link to="/about" class="nav-link">About</router-link>
            </li>
            <li v-if="(header[4]) ? header[4].status : false" class="nav-item">
              <router-link  to="/contact" class="nav-link">Contact Us</router-link>
            </li>

            <li v-for="(pg, idy) in pages" :key="'p'+idy" :class="(pg.has_header) ? '' : 'hidden'" 
                  class="nav-item">
                  <router-link :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                        class="nav-link">
                        {{ pg.title }}
                </router-link>
            </li>
            
          </ul>
            <form class="form-inline my-2 my-lg-0 dropdown">


            <button v-if="authenticated"
                  type="button"
                  name="button"
                  class="navbar-action"
                  data-toggle="dropdown">
                <div class="showDropdown">
                    <img :src="(avatar) ? avatar : require('../assets/img/avatar.jpg')" 
                        alt="" 
                        class="img-fluid" 
                        style="width:38px;height:38px;border-radius: 50%;">
                    <div class="dropdown-menu">
                      <router-link to="/me/profile" class="dropdown-item">Profile</router-link>
                      <a href="javascript:;" class="dropdown-item" @click="logout()">Logout</a>
                    </div>
                </div>
            </button>

              <li class="nav-item line-r" v-if="!authenticated">
                <router-link to="/login" class="nav-link">
                  <img src="../assets/images/icons/user.svg" alt="" class="svg-icon">
                </router-link>
              </li>


              <li class="nav-item">
                <router-link v-if="!searchPage" :to="{ name: 'search' }" class="nav-link">
                  <img src="../assets/images/icons/search.svg" alt="" class="svg-icon">
                </router-link>
                <router-link v-else :to="{ name: 'home' }" class="nav-link">
                  <img src="../assets/images/icons/cancel.svg" alt="" class="svg-icon">
                </router-link>
              </li>
          </form>
        </div>
      </div>
    </nav> -->
  <SearchPopup v-if="toggleSearch" />
  </div>
</template>


<style scoped>
.hidden { display: none !important }
.nav-link {
  font-size: 20px;
  padding: 0;
}
.fluid-search #navbarSupportedContent ul.navbar-nav {
  visibility: hidden;
}
.showDropdown {
  position: relative;
}
.menu-bar {
  position: relative;
  width: 40px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  height: 22px;
  margin-left: 13px;
  display: none;
}
.menu-bar > div {
  width: 100%;
  height: 2px;
  background: #fff;
  border-radius: 2px;
}
.iaa-navbar {
  /* background: #000; */
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10000000;
  padding: 15px 0;
  -webkit-transition: all 0.2s ease-in-out;
  -moz-transition: all 0.2s ease-in-out;
  -o-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.iaa-navbar.active {
  background: #000;
}
.nav-logo {
  margin: 0;
}
.nav-logo img {
  width: 75px;
  height: auto;
  transform: none;
}
.iaa-navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logo-title {
  color: #EFC800;
  font-weight: bold;
  font-size: 2.5rem;
  margin-left: 10px;
}
.nav-logo {
  display: flex;
  align-items: center;
}
.iaa-navbar-links {
  display: flex;
}
.iaa-navbar-links a:hover {
  color: #EFC800;
}
.iaa-navbar-links a {
  color: #fff;
  padding-right: 1.1rem;
  padding-left: 1.1rem;
  font-size: 20px;
  font-weight: 600;
}
.iaa-navbar-sa button {
  display: flex;
}
.iaa-navbar-sa span,
.iaa-navbar-sa span:before {
  font-size: 23px;
  color: #fff;
  padding: 3px;
}
.iaa-nav-line {
  margin: 0 9px;
}
.hidden-sm {
  display: none;
}

 /* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {}

@media (max-width: 767.98px) {
  .nav-logo img {
    width: 60px;
  }
  .iaa-navbar-links {
    top: 88.79px !important;
    height: calc(100% - 88.79px) !important;
  }
}

@media (max-width: 1199.98px) {
  .iaa-navbar-links {
    position: fixed;
    width: 100%;
    top: 103.49px;
    left: 0;
    height: calc(100% - 103.49px);
    background: #000;
    z-index: 100;
    display: block;
    padding-left: 15px;
    padding-right: 15px;
    border-top: 1px solid #fff;
    display: none;
    overflow-y: auto;
  }
  .hidden-sm {
    display: block;
  }
  .iaa-navbar-links.active {
    display: block;
  }
  .menu-bar {
    display: flex;
  }
  .iaa-navbar-links a {
    font-size: 32px;
    padding: 0.5rem 0;
    border-bottom: 1px solid #fff
  }
  .logo-title {
    font-size: 30px;
  }
  .iaa-nav-line {
    margin: 0 3px
  }
}

 /* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {}

 /* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {}

 /* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {}

 /* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {}
</style>

<script>
import axios from "axios";
import SearchPopup from "./SearchPopup.vue";
export default {
  name: "Navbar",
  props: ['close'],
  components: {
    SearchPopup
  },
  data() {
    return {
      pgLoading: false,
      logo: [],
      header: [],
      pages: [],
      socials: [],
      searchPage: false,
      avatar: '',
      authenticated: false,
      toggleSearch: false,
      toggleNavbar: false,
      popularSearch: []
    };
  },
  created() {

    // Get Navbar Links
    axios
      .get(window.baseURL + "/popularSearch")
      .then((res) => {
        var data = res.data.rows;
        this.popularSearch = res.data.rows;
      })
      .catch(() => {});

    if (this.$route.path == '/search') {
      this.searchPage = true;
    } else {
      this.searchPage = false;
    }
    console.log(this.$route.path);
    
    if (!localStorage.getItem("access_token")) {
      this.authenticated = false;
    } else {
      this.authenticated = true;
    }

    if(!localStorage.getItem("avatar")) {
      this.avatar = false;
    } else {
      this.avatar = localStorage.getItem("avatar");
    }

    this.fetchLogo();
    this.fetchPages();
    this.scrollToTop();
  },
  mounted() {
    if ($(window).scrollTop() > 0) {
        $('.iaa-navbar').addClass('active');
    } 
    
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            $('.iaa-navbar').addClass('active');
        } else {
            $('.iaa-navbar').removeClass('active');
        }
    });
  },
  methods: {
    //

    opnPopular(slug) {
      this.$router.push({ name: "show-popular-search", params:{slug: slug }});
      // refersh
      location.reload();
    },

    scrollToTop() {
      window.scrollTo(0,0);
    },  

    fetchLogo() {
      // Get Navbar Links
      axios
        .get(window.baseURL + "/setting")
        .then((res) => {
          var data = 
          this.logo = res.data.logo;
          this.socials = res.data.social;
          this.header = res.data.header;
        })
        .catch(() => {});
    },


    //Get Navbar Links in Big Sizes
    fetchPages(){
    axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
    },

    logout(){
      localStorage.clear();
      this.$router.push({ name: 'login' });
    },

    openMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.add('active');
        el2.classList.add('active');
    },

    closeMenu() {
        let el1 = document.querySelector(".navbar-container");
        let el2 = document.querySelector(".navbar-backdrop");
        el1.classList.remove('active');
        el2.classList.remove('active');
    }

  }
};
</script>
